import styled from 'styled-components';

export const SliceTableStyle = styled.table`
  margin-bottom: 1em;
  width:100%;
  table-layout: fixed;
  
  img {
    margin:unset;
  }

  th, tr, td {
    padding-bottom:0.5em;
    padding: 0.5em;
    max-width:100%;
    word-wrap: break-word;
  }

  td, th:nth-child(1) {
    width: 30%;
  }
  
  td, th:nth-child(2) {
    width: 70%;
  }

  @media (min-width: 767px) {
    td, th:nth-child(1) {
      width: 20%;
    }
    td, th:nth-child(2) {
      width: 80%;
    }
  }
`